import { useEffect } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { personalDataSelector, reset } from "@/domains/createCharacter/slice";

export default () => {
  const personalData = useAppSelector(personalDataSelector);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(reset());
  }, [personalData.gender, dispatch]);
};
